import { DialogTitle as MuiDialogTitle, Typography as MuiTypography } from '@mui/material';
import type { MouseEventHandler, ReactNode } from 'react';

import { CloseIcon } from '../../../icons';
import { IconButton } from '../../atoms/IconButton';

const ROOT_ELEMENT = 'div';
const HEADING_ELEMENT = 'h2';

const TITLE_LAYOUT = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  paddingRight: 2,
} as const;

const HEADING_LAYOUT = {
  flex: '1 1 auto',
} as const;

type Props = {
  children: ReactNode;
  id?: string;
  closeLabel: string;
  onClose: MouseEventHandler<HTMLButtonElement>;
};

export function DialogTitle(props: Props) {
  return (
    <MuiDialogTitle component={ROOT_ELEMENT} sx={TITLE_LAYOUT}>
      <MuiTypography id={props.id} variant="inherit" component={HEADING_ELEMENT} sx={HEADING_LAYOUT}>
        {props.children}
      </MuiTypography>
      <IconButton tooltip={props.closeLabel} edge="end" onClick={props.onClose}>
        <CloseIcon />
      </IconButton>
    </MuiDialogTitle>
  );
}

export type { Props as DialogTitleProps };
